import {Vue} from '~/addiesaas'
import ConfirmBar from './confirm-bar'
import ConfirmModal from './confirm-modal'
import ConfirmBarCheckbox from './confirm-bar-checkbox.vue'

Vue.component(ConfirmBar.name, ConfirmBar)
Vue.component(ConfirmModal.name, ConfirmModal)
Vue.component(ConfirmBarCheckbox.name, ConfirmBarCheckbox)

export default {
    ConfirmBar,
    ConfirmModal,
    ConfirmBarCheckbox
}
